import React from 'react';

const MetricCard = ({
    title = '',
    value = '',
    description = '',
    backgroundColor = '',
    className = ''
}) => {
    return (
        <div
            className={`${className} rounded-xl p-6 text-white transition-transform hover:scale-105 overflow-hidden`}
            style={{
                minHeight: '160px',
                display: 'flex',
                flexDirection: 'column',
                // justifyContent: 'space-between',
                backgroundColor: backgroundColor,
                boxShadow: `0px 25px 30px -30px ${backgroundColor}`
            }}
        >
            <div className="text-sm font-medium opacity-80 uppercase tracking-wide flex flex-col justify-start items-start h-11">
                {title}
            </div>
            <div>
                <div className="text-3xl font-medium mb-1">
                    {value}
                </div>
                <div className="text-sm opacity-90 leading-snug">
                    {description}
                </div>
            </div>
        </div>
    );
};

export default MetricCard;